import { ReactNode } from 'react';
import { InputLabel } from './InputLabel';
import './DateInput.css';

import DT from 'react-datetime';
// @ts-ignore
const DateTime = DT.default ? DT.default : DT;

export const DateInput = ({
  label,
  value,
  onChange,
}: {
  label?: ReactNode;
  value: string | Date;
  onChange: (val: string) => any;
}) => {
  return (
    <div>
      <InputLabel {...{ label }} />
      <DateTime
        value={value instanceof Date ? value : new Date(value)}
        onChange={(val) => onChange(val.format('YYYY-MM-DD'))}
        inputProps={{ readOnly: true }}
        timeFormat={false}
        className={`datetimeinput`}
      />
    </div>
  );
};
